import type { ReactNode, RefObject } from "react";
import type { GridApi } from "~/components/grid/AgGrid";
import type { SsrmExportSource } from "~/helpers/grid/ssrmExportSource";

import GridFileExportProvider from "~/components/grid/export/GridFileExportProvider";
import toExportFileNamePrefix from "~/helpers/grid/toExportFileNamePrefix";
import useGridFileExport from "~/hooks/useGridFileExport";

interface DefaultServerSideFileExportProps {
	children: ReactNode;
	gridDataKey: string;
	gridRef: RefObject<{ api: GridApi } | null>;
	source: SsrmExportSource<never, never>;
}

const EXCEL_SHEET_NAME_MAX_LENGTH = 31;

// Gives a server-side grid the full export (ribbon and right-click) when its page did not wire a provider.
const DefaultServerSideFileExport = ({ children, gridDataKey, gridRef, source }: DefaultServerSideFileExportProps) => {
	const fileExport = useGridFileExport<never>({
		fileNamePrefix: toExportFileNamePrefix(gridDataKey),
		gridRef,
		serverSide: source,
		sheetName: toExportFileNamePrefix(gridDataKey).slice(0, EXCEL_SHEET_NAME_MAX_LENGTH)
	});
	return <GridFileExportProvider value={fileExport}>{children}</GridFileExportProvider>;
};

export default DefaultServerSideFileExport;
